/* Autorisations */

export const AUTHORIZATIONS_AUTHORIZATION_VALUE_COUNTRIES_VIEW_ANY =
  "countries.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_COUNTRIES_VIEW =
  "countries.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_COUNTRIES_CREATE =
  "countries.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_COUNTRIES_UPDATE =
  "countries.update"

// Environments
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_ENVIRONMENTS_CREATE =
  "environments.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_ENVIRONMENTS_VIEW_ANY =
  "environments.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_ENVIRONMENTS_VIEW =
  "environments.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_ENVIRONMENTS_QUOTAS =
  "environments.quptas"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_ENVIRONMENTS_UPDATE =
  "environments.update"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_ENVIRONMENTS_DELETE =
  "environments.delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_ENVIRONMENTS_SOFT_DELETE =
  "environments.soft_delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_ENVIRONMENTS_RESTORE =
  "environments.restore"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_ENVIRONMENTS_UPDATE_RECORDS_ACCOUNTS =
  "environments.update_records_accounts"

// Users/Groups
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_USERS_GROUPS_VIEW_ANY =
  "users.groups.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_USERS_GROUPS_VIEW =
  "users.groups.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_USERS_GROUPS_CREATE =
  "users.groups.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_USERS_GROUPS_UPDATE =
  "users.groups.update"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_USERS_GROUPS_DELETE =
  "users.groups.delete"

// Users/Admins
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_USERS_ADMINS_VIEW_ANY =
  "users.admins.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_USERS_ADMINS_VIEW =
  "users.admins.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_USERS_ADMINS_CREATE =
  "users.admins.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_USERS_ADMINS_UPDATE =
  "users.admins.update"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_USERS_ADMINS_DELETE =
  "users.admins.delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_USERS_ADMINS_PASSWORD_RESETS =
  "users.admins.password_resets"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_USERS_ADMINS_ACCESS_TOKENS =
  "users.admins.access_tokens"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_USERS_ADMINS_AUTOCOMPLETE =
  "users.admins.autocomplete"

// Files
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_FILES_VIEW_ANY =
  "files.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_FILES_VIEW = "files.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_FILES_CREATE = "files.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_FILES_UPDATE = "files.update"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_FILES_DELETE = "files.delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_FILES_SOFT_DELETE =
  "files.soft_delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_FILES_RESTORE = "files.restore"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_FILES_DOWNLOAD =
  "files.download"

// Customers
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CUSTOMERS_VIEW_ANY =
  "users.customers.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CUSTOMERS_VIEW =
  "users.customers.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CUSTOMERS_CREATE =
  "users.customers.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CUSTOMERS_UPDATE =
  "users.customers.update"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CUSTOMERS_DELETE =
  "users.customers.delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CUSTOMERS_SOFT_DELETE =
  "users.customers.soft_delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CUSTOMERS_RESTORE =
  "users.customers.restore"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CUSTOMERS_ENABLE =
  "users.customers.enable"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CUSTOMERS_DISABLE =
  "users.customers.disable"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CUSTOMERS_AUTOCOMPLETE =
  "users.customers.autocomplete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CUSTOMERS_PASSWORD_RESETS =
  "users.customers.password_resets"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CUSTOMERS_ACCESS_TOKENS =
  "users.customers.access_tokens"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CUSTOMERS_TWO_FACTOR_AUTHENTICATION =
  "users.customers.two_factor_authentication"

// Patrimonies
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PATRIMONIES_VIEW_ANY =
  "patrimonies.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PATRIMONIES_VIEW =
  "patrimonies.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PATRIMONIES_CREATE =
  "patrimonies.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PATRIMONIES_UPDATE =
  "patrimonies.update"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PATRIMONIES_DELETE =
  "patrimonies.delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PATRIMONIES_SOFT_DELETE =
  "patrimonies.soft_delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PATRIMONIES_RESTORE =
  "patrimonies.restore"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PATRIMONIES_DOWNLOAD_BATCH =
  "patrimonies.download_batch"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PATRIMONIES_VIEW_TREE =
  "patrimonies.view_tree"

// Patrimonies/Categories
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PATRIMONIES_CATEGORIES_VIEW_ANY =
  "patrimonies.categories.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PATRIMONIES_CATEGORIES_VIEW =
  "patrimonies.categories.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PATRIMONIES_CATEGORIES_CREATE =
  "patrimonies.categories.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PATRIMONIES_CATEGORIES_UPDATE =
  "patrimonies.categories.update"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PATRIMONIES_CATEGORIES_DELETE =
  "patrimonies.categories.delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PATRIMONIES_CATEGORIES_SOFT_DELETE =
  "patrimonies.categories.soft_delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PATRIMONIES_CATEGORIES_RESTORE =
  "patrimonies.categories.restore"

// Contracts/FamilyTypes
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_FAMILY_TYPES_VIEW_ANY =
  "contracts.family_types.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_FAMILY_TYPES_VIEW =
  "contracts.family_types.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_FAMILY_TYPES_CREATE =
  "contracts.family_types.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_FAMILY_TYPES_UPDATE =
  "contracts.family_types.update"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_FAMILY_TYPES_DELETE =
  "contracts.family_types.delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_FAMILY_TYPES_SOFT_DELETE =
  "contracts.family_types.soft_delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_FAMILY_TYPES_RESTORE =
  "contracts.family_types.restore"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_FAMILY_TYPES_AUTOCOMPLETE =
  "contracts.family_types.autocomplete"

// Contracts
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_VIEW_ANY =
  "contracts.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_VIEW =
  "contracts.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_CREATE =
  "contracts.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_UPDATE =
  "contracts.update"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_DELETE =
  "contracts.delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SOFT_DELETE =
  "contracts.soft_delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_RESTORE =
  "contracts.restore"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_ACTIVATE =
  "contracts.activate"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_FINISH =
  "contracts.finish"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_CANCEL =
  "contracts.cancel"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_DUPLICATE =
  "contracts.duplicate"

// Interventions
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_INTERVENTIONS_VIEW_ANY =
  "interventions.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_INTERVENTIONS_VIEW =
  "interventions.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_INTERVENTIONS_SOFT_DELETE =
  "interventions.soft_delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_INTERVENTIONS_DELETE =
  "interventions.delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_INTERVENTIONS_RESTORE =
  "interventions.restore"

// Contracts/Schedules
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_VIEW_ANY =
  "contracts.schedules.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_VIEW =
  "contracts.schedules.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_CREATE =
  "contracts.schedules.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_UPDATE =
  "contracts.schedules.update"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_DELETE =
  "contracts.schedules.delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_SOFT_DELETE =
  "contracts.schedules.soft_delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_RESTORE =
  "contracts.schedules.restore"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_ENABLE =
  "contracts.schedules.enable"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_DISABLE =
  "contracts.schedules.disable"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_DUPLICATE =
  "contracts.schedules.duplicate"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_ESTIMATE =
  "contracts.schedules.estimate"

// Contracts/Schedules/Requirements
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_REQUIREMENTS_VIEW_ANY =
  "contracts.schedules.requirements.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_REQUIREMENTS_VIEW =
  "contracts.schedules.requirements.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_REQUIREMENTS_CREATE =
  "contracts.schedules.requirements.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_REQUIREMENTS_UPDATE =
  "contracts.schedules.requirements.update"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_REQUIREMENTS_DELETE =
  "contracts.schedules.requirements.delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_REQUIREMENTS_SOFT_DELETE =
  "contracts.schedules.requirements.soft_delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_REQUIREMENTS_RESTORE =
  "contracts.schedules.requirements.restore"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_REQUIREMENTS_UPDATE_ORDER =
  "contracts.schedules.requirements.update_order"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_REQUIREMENTS_DUPLICATE =
  "contracts.schedules.requirements.duplicate"

// Contracts/Schedules/Requirements/ChecklistItems
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_REQUIREMENTS_CHECKLIST_ITEMS_CREATE =
  "contracts.schedules.requirements.checklist_items.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_REQUIREMENTS_CHECKLIST_ITEMS_UPDATE =
  "contracts.schedules.requirements.checklist_items.update"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_REQUIREMENTS_CHECKLIST_ITEMS_DELETE =
  "contracts.schedules.requirements.checklist_items.delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_REQUIREMENTS_CHECKLIST_ITEMS_SOFT_DELETE =
  "contracts.schedules.requirements.checklist_items.soft_delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_REQUIREMENTS_CHECKLIST_ITEMS_RESTORE =
  "contracts.schedules.requirements.checklist_items.restore"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_REQUIREMENTS_CHECKLIST_ITEMS_UPDATE_ORDER =
  "contracts.schedules.requirements.checklist_items.update_order"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_REQUIREMENTS_CHECKLIST_ITEMS_DUPLICATE =
  "contracts.schedules.requirements.checklist_items.duplicate"

// Contracts/Schedules/Patrimonies
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_PATRIMONIES_VIEW_ANY =
  "contracts.schedules.patrimonies.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_PATRIMONIES_CREATE =
  "contracts.schedules.patrimonies.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_PATRIMONIES_UPDATE =
  "contracts.schedules.patrimonies.update"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_PATRIMONIES_DELETE =
  "contracts.schedules.patrimonies.delete"

// Contracts/Schedules/Penalties
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_PENALTIES_VIEW_ANY =
  "contracts.schedules.penalties.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_PENALTIES_VIEW =
  "contracts.schedules.penalties.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_PENALTIES_CREATE =
  "contracts.schedules.penalties.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_PENALTIES_UPDATE =
  "contracts.schedules.penalties.update"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_PENALTIES_DELETE =
  "contracts.schedules.penalties.delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_PENALTIES_SOFT_DELETE =
  "contracts.schedules.penalties.soft_delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_PENALTIES_RESTORE =
  "contracts.schedules.penalties.restore"

// Contracts/Schedules/NotificationConfigs
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_NOTIFICATION_CONFIGS_VIEW_ANY =
  "contracts.schedules.notification_configs.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_NOTIFICATION_CONFIGS_VIEW =
  "contracts.schedules.notification_configs.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_NOTIFICATION_CONFIGS_CREATE =
  "contracts.schedules.notification_configs.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_NOTIFICATION_CONFIGS_UPDATE =
  "contracts.schedules.notification_configs.update"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_NOTIFICATION_CONFIGS_DELETE =
  "contracts.schedules.notification_configs.delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_NOTIFICATION_CONFIGS_SOFT_DELETE =
  "contracts.schedules.notification_configs.soft_delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_NOTIFICATION_CONFIGS_RESTORE =
  "contracts.schedules.notification_configs.restore"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_NOTIFICATION_CONFIGS_ENABLE =
  "contracts.schedules.notification_configs.enable"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_NOTIFICATION_CONFIGS_DISABLE =
  "contracts.schedules.notification_configs.disable"

// Contracts/Schedules/Occurrences
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_OCCURRENCES_VIEW_ANY =
  "contracts.schedules.occurrences.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_OCCURRENCES_VIEW =
  "contracts.schedules.occurrences.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_OCCURRENCES_CREATE =
  "contracts.schedules.occurrences.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_OCCURRENCES_CANCEL =
  "contracts.schedules.occurrences.cancel"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_CONTRACTS_SCHEDULES_OCCURRENCES_UPDATE =
  "contracts.schedules.occurrences.update"

// Providers
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PROVIDERS_VIEW_ANY =
  "providers.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PROVIDERS_VIEW =
  "providers.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PROVIDERS_CREATE =
  "providers.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PROVIDERS_UPDATE =
  "providers.update"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PROVIDERS_DELETE =
  "providers.delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PROVIDERS_SOFT_DELETE =
  "providers.soft_delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PROVIDERS_RESTORE =
  "providers.restore"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PROVIDERS_AUTOCOMPLETE =
  "providers.autocomplete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PROVIDERS_CALENDAR =
  "providers.calendar"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PROVIDERS_ENABLE =
  "providers.enable"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PROVIDERS_DISABLE =
  "providers.disable"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PROVIDERS_REGENERATE_PIN =
  "providers.regenerate_pin"

// Alerts
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_ALERTS_VIEW_ANY =
  "alerts.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_ALERTS_VIEW = "alerts.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_ALERTS_ACKNOWLEDGE =
  "alerts.acknowledge"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_ALERTS_SOFT_DELETE =
  "alerts.soft_delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_ALERTS_DELETE = "alerts.delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_ALERTS_RESTORE =
  "alerts.restore"

// PenaltyRecords
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PENALTY_RECORDS_VIEW_ANY =
  "penalty_records.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PENALTY_RECORDS_VIEW =
  "penalty_records.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PENALTY_RECORDS_CREATE =
  "penalty_records.create"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PENALTY_RECORDS_SOFT_DELETE =
  "penalty_records.soft_delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PENALTY_RECORDS_DELETE =
  "penalty_records.delete"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_PENALTY_RECORDS_RESTORE =
  "penalty_records.restore"

// Tasks
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_TASKS_VIEW_ANY =
  "tasks.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_TASKS_VIEW = "tasks.view"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_TASKS_RETRY = "tasks.retry"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_TASKS_CANCEL = "tasks.cancel"

// Tasks logs
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_TASKS_LOGS_VIEW_ANY =
  "tasks.logs.view_any"
export const AUTHORIZATIONS_AUTHORIZATION_VALUE_TASKS_LOGS_VIEW =
  "tasks.logs.view"
